const geofence = {
  name: "Geofence",
  geofenceName: "Name of geofence",
  in: "Drive in",
  out: "Drive out",
  shape: {
    name: "Shape of fence",
    circle: "Circle",
    rectangle: "Rectangle",
    polygon: "Polygon",
    warning: {
      circle: "Please set the center and radius",
      rectangle: "Please draw a rectangle",
      polygon: "Please draw at least 3 points"
    }
  },
  radius: "Radius(m)",
  centerPosition: "Center",
  mapPoint: "Select points from the map",
  style: {
    queryLabelWidth: "120px",
    formLabelWidth: "90px",
    formLabelWidth2: "160px"
  }
} 
export default geofence